export const hdData = {
  banner:
    'http://image.acmcoder.com/v1/acmimg/5514231444072460.jpg?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2018-07-31T04%3A25%3A35Z%2F-1%2F%2F85098aefef644cc32813b642eac9127c180b2c3ee6b7be59c398207406afbc45',
  title: '校园招聘真题训练专区',
  comp_logo:
    'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
  comp_name: '京东',
  qr_code:
    'http://image.acmcoder.com/v1/acmimg/414481710603538.jpg?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-03-15T02%3A09%3A07Z%2F-1%2F%2Fd3fda009d71700544b51c454faaaaf23437d3614130326da4c34c9fe167541fa'
}
export const companyCellItems = [
  { icon: 'el-icon-s-cooperation', num: '0', title: '职位分类' },
  { icon: 'el-icon-document-copy', num: '0', title: '试卷数量' },
  { icon: 'el-icon-menu', num: '0', title: '试题数量' },
  { icon: 'el-icon-s-custom', num: '0', title: '做题人数' }
]



// WEBPACK FOOTER //
// ./src/pages/practice/company-code/config.js